import React from "react";
import { Redirect, Route, Switch } from "react-router";
import styles from './layout/layout.module.scss'
import Login from "./views/Auth/Login";
import NewPassword from "./views/Auth/NewPassword";
import TwoFA from "./views/Auth/Login/2fa";

export default function AuthLayout() {
  return (
    <div className={styles.authLayout}>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/2fa" component={TwoFA} />
        <Route path="/admin/new-password" component={NewPassword} />
        <Redirect to="/login" />
      </Switch>
    </div>
  );
}
